import { render, staticRenderFns } from "./VacancySolicitants.vue?vue&type=template&id=1922ca24"
import script from "./VacancySolicitants.vue?vue&type=script&lang=js"
export * from "./VacancySolicitants.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports